import {
	Box,
	Breadcrumbs,
	Button,
	FormControl,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Select,
	Stack,
	TextField,
	useMediaQuery,
	useTheme,
} from '@mui/material'
import {
	BtnBox,
	PageBg2,
	PageWrap,
	SearchRowItem,
	TitleText,
} from 'components/FrameworkStyle'
import { getSettings } from 'helpers/storage'
import { selectuserInfo } from 'hooks/userInfo'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import ClientSearchPopup from 'views/test/clientSearchPopup'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ko'
import dayjs from 'dayjs'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import moment from 'moment'
import 'moment/locale/ko'
import { alertModal, compareDate, isValidDateType } from 'util/util'
import DownloadIcon from '@mui/icons-material/Download'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import { PageBg } from 'components/ComponentStyles'
import {
	DataGridPremium,
	GridColDef,
	GridColumnGroupingModel,
	GridDensity,
	GridSelectionModel,
	GridToolbar,
	koKR,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import { apiPatientAntibioticStatList } from 'api/api'
import ExcelJS from 'exceljs'

const locale = 'ko'

const ByPatient = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const userInfo = useSelector(selectuserInfo)

	const env = getSettings()
	const [disabledSearch, setDisabledSearch] = useState(false)
	const [disabledReset, setDisabledReset] = useState(false)

	const [dateRange, setDateRange] = useState('1m')

	const [search, setSearch] = useState({
		clientID: userInfo.infoType === 'C' ? userInfo.clientID : 0,
		startDate: moment(new Date()).isBefore('2023-08')
			? '2023-08'
			: moment().subtract(1, 'months').format('YYYY-MM'),
		endDate: moment().format('YYYY-MM'),
		searchType: 'R',
		eqpMicroNm: '0',
		antiName: '0',
		patientName: '',
		specimenName: '0',
		testName: '0',
		isAdmin: userInfo.infoType === 'C' ? 0 : 1,
	})

	const [eqpMicroList, setEqpMicroList] = useState<
		Array<{ eqpMicroNm: string }>
	>([])
	const [antiNameList, setAntiNameList] = useState<Array<{ antiName: string }>>(
		[],
	)
	const [specimenNameList, setSpecimenNameList] = useState<
		Array<{ specimenName: string }>
	>([])
	const [testNameList, setTestNameList] = useState<Array<{ testName: string }>>(
		[],
	)

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}

	const actionSearch = () => {
		const startMonth = moment(search.startDate, ['YYYY-MM', 'YYYY-MM-DD'], true)
		const endMonth = moment(search.endDate, ['YYYY-MM', 'YYYY-MM-DD'], true)

		if (!startMonth.isValid() || !endMonth.isValid()) {
			alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
			return
		}

		if (endMonth.isBefore(startMonth, 'month')) {
			alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
			return
		}

		if (
			endMonth.startOf('month').diff(startMonth.startOf('month'), 'months') > 12
		) {
			alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
			return
		}

		if (search.clientID === 0 || search.clientID === null) {
			alertModal('거래처를 선택해주세요.', 'error', () => {})
			return
		}

		setGridMstLoading(true)
		setDisabledSearch(true)

		const request = {
			...search,
			eqpMicroNm: search.eqpMicroNm === '0' ? '' : search.eqpMicroNm,
			antiName: search.antiName === '0' ? '' : search.antiName,
			specimenName: search.specimenName === '0' ? '' : search.specimenName,
			testName: search.testName === '0' ? '' : search.testName,
		}

		apiPatientAntibioticStatList(request)
			.then((res) => {
				console.log('API 응답:', res)

				setSelectionModel([])

				if (res.length === 0) {
					setColumns([])
					setRows([])
				}

				if (res[0]?.success === 0 && res[0]?.message) {
					alertModal(
						res[0]?.message || '조회 중 오류가 발생했습니다.',
						'error',
						() => {},
					)
					setColumns([])
					setRows([])
					return
				} else {
					// 고정 컬럼 정의
					const baseColumns: GridColDef[] = [
						{
							field: 'id',
							headerName: 'ID',
							width: 100,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'PatientName',
							headerName: '수진자명',
							width: 150,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'BirthDay',
							headerName: '생년월일',
							width: 120,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'Gender',
							headerName: '성별',
							width: 80,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'PatientAge',
							headerName: '나이',
							width: 80,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'ClientName',
							headerName: '거래처명',
							width: 200,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'DisplayName',
							headerName: '검사명',
							width: 150,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'SpecimenName',
							headerName: '검체명',
							width: 150,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'ReceptionDate',
							headerName: '접수일자',
							width: 120,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'ReceptionRegNum',
							headerName: '접수번호',
							width: 120,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'EqpAccSeq',
							headerName: '배양번호',
							width: 120,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'EqpMicroNm',
							headerName: '균주명',
							width: 200,
							headerAlign: 'center',
							headerClassName: 'id-column',
						},
						{
							field: 'Cre',
							headerName: '감염6종',
							width: 100,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'id-column',
						},
					]

					// 맨 마지막에 표시할 컬럼
					const endColumns: GridColDef[] = [
						{
							field: 'D90',
							headerName: '보고일',
							width: 120,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'add-column',
						},
						{
							field: 'ColonyCount',
							headerName: '증식균수',
							width: 120,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'add-column',
						},
						{
							field: 'ChartNo',
							headerName: '차트번호',
							width: 120,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'add-column',
						},
						{
							field: 'Ward',
							headerName: '병동',
							width: 120,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'add-column',
						},
						{
							field: 'DoctorName',
							headerName: '진료의',
							width: 120,
							headerAlign: 'center',
							align: 'center',
							headerClassName: 'add-column',
						},
					]

					// 고정 컬럼 필드명 목록
					const baseFieldNames = baseColumns.map((col) => col.field)
					const endFieldNames = endColumns.map((col) => col.field)

					// baseColumns에 headerClassName 일괄 추가
					baseColumns.forEach((col, index) => {
						// 마지막 index가 아니면
						if (index !== baseColumns.length - 1) {
							col.headerClassName = 'basic-info-header'
						} else {
							col.headerClassName = 'basic-info-header last-basic-header'
						}
					})

					// 동적 컬럼 추출 (모든 행에서 키를 수집하여 고정 컬럼을 제외한 나머지 필드)
					const dynamicColumns: GridColDef[] = []
					if (res.length > 0) {
						const noAntiDynamicFields = ['NoAntiMic', 'NoAntiRes']
						// 모든 행에서 키를 수집하여 유니크한 키 목록 생성
						const allKeysSet = new Set<string>()
						res.forEach((row: Record<string, unknown>) => {
							Object.keys(row).forEach((key) => allKeysSet.add(key))
						})
						const dynamicKeys = Array.from(allKeysSet).filter(
							(key) =>
								!baseFieldNames.includes(key) &&
								!endFieldNames.includes(key) &&
								!noAntiDynamicFields.includes(key) &&
								key !== 'success',
						)

						// 동적 키 정렬: 같은 항생제별로 MIC → RIS 순서
						const sortedDynamicKeys = dynamicKeys.sort((a, b) => {
							const getPrefixAndType = (key: string) => {
								if (key.includes('_MIC'))
									return { prefix: key.replace('_MIC', ''), type: 0 }
								if (key.includes('_RIS'))
									return { prefix: key.replace('_RIS', ''), type: 1 }
								return { prefix: key, type: 2 }
							}
							const aInfo = getPrefixAndType(a)
							const bInfo = getPrefixAndType(b)
							// 접두사(항생제명)로 먼저 정렬, 같으면 타입(MIC=0, RIS=1)으로 정렬
							if (aInfo.prefix !== bInfo.prefix) {
								return aInfo.prefix.localeCompare(bInfo.prefix)
							}
							return aInfo.type - bInfo.type
						})

						// 동적 컬럼 그룹핑을 위한 접두사별 필드 목록 생성
						const prefixFieldsMap = new Map<string, string[]>()
						const orderedDynamicKeys = [
							...sortedDynamicKeys,
							...noAntiDynamicFields.filter((key) => allKeysSet.has(key)),
						]

						orderedDynamicKeys.forEach((key, index) => {
							let prefix = key
							const isNoAntibioticColumn = key === 'NoAntiMic' || key === 'NoAntiRes'

							if (isNoAntibioticColumn) {
								prefix = 'noAntibiotic'
							}
							if (key.includes('_MIC')) prefix = key.replace('_MIC', '')
							else if (key.includes('_RIS')) prefix = key.replace('_RIS', '')

							if (!prefixFieldsMap.has(prefix)) {
								prefixFieldsMap.set(prefix, [])
							}
							prefixFieldsMap.get(prefix)!.push(key)

							dynamicColumns.push({
								field: key,
								headerName:
									key === 'NoAntiMic'
										? 'MIC'
										: key === 'NoAntiRes'
											? '결과'
											: key.includes('_MIC')
												? 'MIC'
												: key.includes('_RIS')
													? '결과'
													: key,
								minWidth: 80,
								flex: 1,
								headerAlign: 'center',
								align: 'center',
								headerClassName: `dynamic-header dynamic-header-${index === 0 ? 'first' : index === orderedDynamicKeys.length - 1 ? 'last' : 'middle'}`, // 접두사별로 클래스명 추가
							})
						})

						// 컬럼 그룹핑 모델 생성
						const groupingModel: GridColumnGroupingModel = [
							{
								groupId: 'basicInfo',
								headerName: '기본정보',
								headerAlign: 'center',
								headerClassName: 'basic-header',
								children: baseFieldNames.map((field) => ({ field })),
							},
						]

						// 동적 컬럼 그룹 추가 (항생제별)
						Array.from(prefixFieldsMap.entries()).forEach(
							([prefix, fields], index) => {
								console.log(prefix)
								groupingModel.push({
									groupId: `antibiotic_${prefix}`,
									headerName: prefix === 'noAntibiotic' ? '항생제 없음' : prefix,
									headerAlign: 'center',
									headerClassName: `biotic-header group-biotic-border-${index === 0 ? 'first' : index === prefixFieldsMap.size - 1 ? 'last' : 'middle'}`,
									children: fields.map((field) => ({ field })),
								})
							},
						)

						// 부가정보 그룹 추가
						groupingModel.push({
							groupId: 'additionalInfo',
							headerName: '기본정보',
							headerAlign: 'center',
							headerClassName: 'additional-info-header',
							children: endFieldNames.map((field) => ({ field })),
						})

						setColumnGroupingModel(groupingModel)

						// 항생제명 목록 추출 (sortedDynamicKeys에서 _MIC 접두사)
						const antiNameSet = new Set<string>()
						sortedDynamicKeys.forEach((key) => {
							if (key.includes('_MIC')) {
								antiNameSet.add(key.replace('_MIC', ''))
							}
						})
						setAntiNameList(Array.from(antiNameSet).map((antiName) => ({ antiName })))
					}

					// 전체 컬럼 설정
					setColumns([...baseColumns, ...dynamicColumns, ...endColumns])
					setRows(res)

					// Select 박스용 데이터 추출 (고유값만)
					const eqpMicroSet = new Set<string>()
					const specimenNameSet = new Set<string>()
					// const displayNameSet = new Set<string>()

					res.forEach((item: any) => {
						if (item.EqpMicroNm) eqpMicroSet.add(item.EqpMicroNm)
						if (item.SpecimenName) specimenNameSet.add(item.SpecimenName)
						// if (item.DisplayName) displayNameSet.add(item.DisplayName)
					})

					setEqpMicroList(
						Array.from(eqpMicroSet).map((eqpMicroNm) => ({ eqpMicroNm })),
					)
					setSpecimenNameList(
						Array.from(specimenNameSet).map((specimenName) => ({ specimenName })),
					)
					// setTestNameList(
					// 	Array.from(displayNameSet).map((testName) => ({ testName })),
					// )
				}
			})
			.finally(() => {
				setGridMstLoading(false)
				setDisabledSearch(false)
			})
	}
	const actionReset = () => {}
	const actionExcelDownload = async () => {
		setSelectionModel([])

		// 테두리 스타일 정의
		const borderStyle: Partial<ExcelJS.Borders> = {
			top: { style: 'thin', color: { argb: 'FF000000' } },
			left: { style: 'thin', color: { argb: 'FF000000' } },
			bottom: { style: 'thin', color: { argb: 'FF000000' } },
			right: { style: 'thin', color: { argb: 'FF000000' } },
		}
		const groupHeaderFill: ExcelJS.Fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFBDC3C7' },
		}
		const columnHeaderFill: ExcelJS.Fill = {
			type: 'pattern',
			pattern: 'solid',
			fgColor: { argb: 'FFE0E0E0' },
		}

		// 셀 너비 자동 조정 함수
		const autoFitColumns = (
			sheet: ExcelJS.Worksheet,
			colDefs: GridColDef[],
			data: any[],
		) => {
			colDefs.forEach((col, index) => {
				let maxLength = String(col.headerName || '').length
				data.forEach((row) => {
					const cellValue = String(row[col.field] ?? '')
					if (cellValue.length > maxLength) {
						maxLength = cellValue.length
					}
				})
				const column = sheet.getColumn(index + 1)
				column.width = Math.min(Math.max(maxLength * 1.5 + 2, 10), 50)
			})
		}

		// ExcelJS Workbook 생성
		const workbook = new ExcelJS.Workbook()
		const sheet = workbook.addWorksheet('수검자별 항생제 통계')

		// 동적 컬럼 사용 (columns state)
		const exportColumns = columns.filter(
			(col) =>
				col.field !== 'rowNum' && col.field !== 'id' && col.field !== 'ReceptionID',
		)

		const fieldToGroupHeader = new Map<string, string>()
		const mapGroupHeaders = (group: any, headerName: string) => {
			group.children?.forEach((child: any) => {
				if (child.field) {
					fieldToGroupHeader.set(child.field, headerName)
					return
				}
				if (child.children) {
					mapGroupHeaders(child, headerName)
				}
			})
		}

		columnGroupingModel.forEach((group: any) => {
			mapGroupHeaders(group, group.headerName || '')
		})

		const groupHeaderValues = exportColumns.map(
			(col) => fieldToGroupHeader.get(col.field) || '',
		)

		const groupHeaderRow = sheet.addRow(groupHeaderValues)

		let mergeStart = 1
		for (let index = 1; index <= groupHeaderValues.length; index += 1) {
			const current = groupHeaderValues[index - 1]
			const next = groupHeaderValues[index]
			if (current !== next) {
				if (current && index > mergeStart) {
					sheet.mergeCells(1, mergeStart, 1, index)
				}
				mergeStart = index + 1
			}
		}

		groupHeaderRow.eachCell({ includeEmpty: true }, (cell) => {
			cell.border = borderStyle
			cell.alignment = { horizontal: 'center' }
			cell.fill = groupHeaderFill
			cell.font = { bold: true }
		})

		const headerRow = sheet.addRow(exportColumns.map((col) => col.headerName))
		headerRow.eachCell({ includeEmpty: true }, (cell) => {
			cell.border = borderStyle
			cell.alignment = { horizontal: 'center' }
			cell.fill = columnHeaderFill
			cell.font = { bold: true }
		})

		// 데이터 추가
		rows.forEach((row: any) => {
			const dataRow = sheet.addRow(
				exportColumns.map((col) => row[col.field] ?? ''),
			)
			dataRow.eachCell((cell) => {
				cell.border = borderStyle
			})
		})

		// 컬럼 너비 자동 조정
		autoFitColumns(sheet, exportColumns, rows)

		// 엑셀 파일 다운로드
		const buffer = await workbook.xlsx.writeBuffer()
		const blob = new Blob([buffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		})
		const url = window.URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = url
		a.download = `수검자별항생제통계_${moment().format('YYYYMMDD_HHmmss')}.xlsx`
		a.click()
		window.URL.revokeObjectURL(url)
	}

	// 내부사용자일 경우 거래처 선택 팝업
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		setClientDialogOpen(false)
	}

	// calulate today before n months
	const getBeforeMonth = (n: number) => {
		setSearch({
			...search,
			startDate: moment().subtract(n, 'months').format('YYYY-MM'),
		})
	}

	// calulate today before 1 year
	const getBeforeYear = (n: number) => {
		setSearch({
			...search,
			startDate: moment().subtract(n, 'years').format('YYYY-MM'),
		})
	}

	const searchDateRanageOnChange = (event: any) => {
		switch (event.target.value) {
			case '1m':
				getBeforeMonth(1)
				break
			case '3m':
				getBeforeMonth(3)
				break
			case '6m':
				getBeforeMonth(6)
				break
			case '1y':
				getBeforeYear(1)
				break
			default:
				break
		}
		setDateRange(event.target.value)
		setDisabledSearch(false)
	}

	// date picker on change event
	const dateRanageOnChange = (e: any, target: string) => {
		if (moment(new Date(e)).isBefore('2023-08')) {
			alertModal('2023-08 이전 날짜는 조회할 수 없습니다.', 'error', () => {})
			setSearch({
				...search,
				startDate: '2023-08',
			})
			return
		} else {
			if (moment(new Date(e)).format('yyyy-MM').length === 7) {
				if (!isValidDateType(e)) {
					alertModal('날짜 형식이 올바르지 않습니다.', 'error', () => {})
					setDisabledSearch(true)
					return
				}

				if (target === 'startDate') {
					let diffValue = compareDate(e, search.endDate)
					if (diffValue > 0) {
						alertModal('시작일이 종료일보다 큽니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
					if (
						moment(search.endDate, ['YYYY-MM', 'YYYY-MM-DD'], true)
							.startOf('month')
							.diff(moment(e).startOf('month'), 'months') > 12
					) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				} else if (target === 'endDate') {
					let diffValue = compareDate(e, search.startDate)
					if (diffValue < 0) {
						alertModal('종료일이 시작일보다 작습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
					if (
						moment(e)
							.startOf('month')
							.diff(
								moment(search.startDate, ['YYYY-MM', 'YYYY-MM-DD'], true).startOf(
									'month',
								),
								'months',
							) > 12
					) {
						alertModal('검색기간은 1년을 초과할 수 없습니다.', 'error', () => {})
						setDisabledSearch(true)
						return
					}
				}

				setDisabledSearch(false)

				setSearch((prevState) => {
					return {
						...prevState,
						[target]: moment(new Date(e)).format('yyyy-MM'),
					}
				})
			} else {
				setDisabledSearch(true)
			}
		}
	}

	// grid
	const mstRef = useGridApiRef()
	const [rows, setRows] = useState([])
	const [columns, setColumns] = useState<GridColDef[]>([
		{
			field: 'id',
			headerName: 'ID',
			width: 100,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'PatientName',
			headerName: '수진자명',
			width: 150,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'BirthDay',
			headerName: '생년월일',
			width: 120,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'Gender',
			headerName: '성별',
			width: 80,
			headerAlign: 'center',
			align: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'ClientName',
			headerName: '거래처명',
			width: 200,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'DisplayName',
			headerName: '검사명',
			width: 150,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'SpecimenName',
			headerName: '검체명',
			width: 150,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'ReceptionDate',
			headerName: '접수일자',
			width: 120,
			headerAlign: 'center',
			align: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'ReceptionRegNum',
			headerName: '접수번호',
			width: 120,
			headerAlign: 'center',
			align: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'EqpAccSeq',
			headerName: '배양번호',
			width: 120,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'EqpMicroNm',
			headerName: '균주명',
			width: 200,
			headerAlign: 'center',
			headerClassName: 'basic-info-header',
		},
		{
			field: 'Cre',
			headerName: '감염6종',
			width: 100,
			headerAlign: 'center',
			align: 'center',
			headerClassName: 'basic-info-header',
		},
	])
	const [columnGroupingModel, setColumnGroupingModel] =
		useState<GridColumnGroupingModel>([
			{
				groupId: 'basicInfo',
				headerName: '기본정보',
				headerAlign: 'center',
				headerClassName: 'basic-header',
				children: [
					{ field: 'id' },
					{ field: 'PatientName' },
					{ field: 'BirthDay' },
					{ field: 'Gender' },
					{ field: 'ClientName' },
					{ field: 'DisplayName' },
					{ field: 'SpecimenName' },
					{ field: 'ReceptionDate' },
					{ field: 'ReceptionRegNum' },
					{ field: 'EqpAccSeq' },
					{ field: 'EqpMicroNm' },
					{ field: 'Cre' },
				],
			},
		])
	const [gridMstLoading, setGridMstLoading] = useState(false)
	const [gridMstPageSize, setGridMstPageSize] = useState(env.row ? env.row : 100)
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])

	useEffect(() => {
		if (userInfo?.infoType === 'C') actionSearch()
	}, [])

	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								수검자별 항생제 통계
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										size="small"
										color="primary"
										variant="contained"
										startIcon={isMdUp && <ContentPasteSearchTwoToneIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledSearch}
										onClick={actionSearch}
									>
										조회
									</Button>
								</span>
								<span>
									<Button
										variant="contained"
										color="secondary"
										size="small"
										startIcon={<DownloadIcon />}
										onClick={actionExcelDownload}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
									>
										엑셀 다운로드
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
						dateFormats={{
							monthAndYear: 'YYYY년 M월',
						}}
					>
						<SearchRowItem>
							<p className="labelText">조회조건</p>
							<Grid
								container
								spacing={1}
							>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="searchType-select-label">기간 유형</InputLabel>
										<Select
											labelId="searchType-select-label"
											id="searchTypee-simple-select"
											value={search.searchType}
											label="기간 유형"
											onChange={(e) => {
												setSearch({
													...search,
													searchType: e.target.value,
												})
											}}
											size={'small'}
										>
											<MenuItem value={'R'}>접수일자</MenuItem>
											{/* <MenuItem value={'D'}>보고일자</MenuItem> */}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										views={['month', 'year']}
										label="시작월"
										minDate={dayjs('2018-03-01')}
										maxDate={dayjs(new Date())}
										inputFormat="YYYY-MM"
										value={search.startDate}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'startDate')
											// setSearch({
											// 	...search,
											// 	startDate: newValue
											// 		? newValue.format('YYYY-MM')
											// 		: search.startDate,
											// })
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												inputProps={{
													...params.inputProps,
													readOnly: true,
												}}
												helperText={null}
												size="small"
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<DatePicker
										views={['month', 'year']}
										label="종료월"
										minDate={dayjs('2018-03-01')}
										maxDate={dayjs(new Date())}
										inputFormat="YYYY-MM"
										value={search.endDate}
										onChange={(newValue) => {
											dateRanageOnChange(newValue, 'endDate')
											// setSearch({
											// 	...search,
											// 	endDate: newValue ? newValue.format('YYYY-MM') : search.endDate,
											// })
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												inputProps={{
													...params.inputProps,
													readOnly: true,
												}}
												helperText={null}
												size="small"
												fullWidth
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="date-range-select-label">조회 기간</InputLabel>
										<Select
											labelId="date-range-select-label"
											id="date-range-simple-select"
											value={dateRange}
											label="조회 기간"
											onChange={searchDateRanageOnChange}
											size={'small'}
										>
											<MenuItem value={'0'}>선택하세요.</MenuItem>
											<MenuItem value={'1m'}>1개월</MenuItem>
											<MenuItem value={'3m'}>3개월</MenuItem>
											<MenuItem value={'6m'}>6개월</MenuItem>
											<MenuItem value={'1y'}>1년</MenuItem>
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="strain-name-select-label">균명</InputLabel>
										<Select
											labelId="strain-name-select-label"
											id="strain-name-simple-select"
											value={search.eqpMicroNm}
											label="균명"
											size={'small'}
											onChange={(e) => {
												setSearch({
													...search,
													eqpMicroNm: e.target.value,
												})
											}}
										>
											<MenuItem value={'0'}>전체</MenuItem>
											{eqpMicroList.map((item, index) => (
												<MenuItem
													key={index}
													value={item.eqpMicroNm}
												>
													{item.eqpMicroNm}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="antibiotic-name-select-label">항생제명</InputLabel>
										<Select
											labelId="antibiotic-name-select-label"
											id="antibiotic-name-simple-select"
											value={search.antiName}
											label="항생제명"
											size={'small'}
											onChange={(e) => {
												setSearch({
													...search,
													antiName: e.target.value,
												})
											}}
										>
											<MenuItem value={'0'}>전체</MenuItem>
											{antiNameList.map((item, index) => (
												<MenuItem
													key={index}
													value={item.antiName}
												>
													{item.antiName}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<TextField
										label="수진자명"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										value={search.patientName}
										onChange={(e) => {
											setSearch({
												...search,
												patientName: e.target.value,
											})
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="testName-select-label">검사항목</InputLabel>
										<Select
											labelId="testName-select-label"
											id="testName-simple-select"
											value={search.testName}
											label="검사항목"
											size={'small'}
											onChange={(e) => {
												setSearch({
													...search,
													testName: e.target.value,
												})
											}}
										>
											<MenuItem value={'0'}>전체</MenuItem>{' '}
											{testNameList.map((item, index) => (
												<MenuItem
													key={index}
													value={item.testName}
												>
													{item.testName}
												</MenuItem>
											))}{' '}
										</Select>
									</FormControl>
								</Grid>
								<Grid
									item
									xs={6}
									sm={3}
									md={2}
								>
									<FormControl fullWidth>
										<InputLabel id="specimenName-select-label">검체</InputLabel>
										<Select
											labelId="specimenName-select-label"
											id="specimenName-simple-select"
											value={search.specimenName}
											label="검체"
											size={'small'}
											onChange={(e) => {
												setSearch({
													...search,
													specimenName: e.target.value,
												})
											}}
										>
											<MenuItem value={'0'}>전체</MenuItem>{' '}
											{specimenNameList.map((item, index) => (
												<MenuItem
													key={index}
													value={item.specimenName}
												>
													{item.specimenName}
												</MenuItem>
											))}{' '}
										</Select>
									</FormControl>
								</Grid>
								{(userInfo.infoType === 'S' || userInfo.infoType === 'W') && (
									<Grid
										item
										xs={6}
										sm={3}
										md={3}
									>
										<TextField
											label="거래처"
											variant="outlined"
											size="small"
											type="text"
											fullWidth
											aria-readonly={true}
											value={searchClientName}
											onClick={clientPopupOpenAction}
										/>
									</Grid>
								)}
							</Grid>
						</SearchRowItem>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				elevation={0}
				sx={{ width: '100%', overflow: 'hidden', mt: 2 }}
			>
				<Grid container>
					<Grid
						item
						xs={12}
					>
						<PageBg>
							<Box
								sx={{
									height: 'calc(100vh - 300px)',
									'@media (max-width: 1199px)': {
										height: '400px',
										overflow: 'auto',
									},
								}}
							>
								<Box sx={{ height: '100%' }}>
									<DataGridPremium
										rows={rows}
										columns={columns}
										columnGroupingModel={columnGroupingModel}
										apiRef={mstRef}
										pageSize={gridMstPageSize}
										onPageSizeChange={(newPageSize) => setGridMstPageSize(newPageSize)}
										rowsPerPageOptions={[5, 10, 20, 50, 100]}
										pagination
										autoHeight={false}
										loading={gridMstLoading}
										components={{
											Toolbar: GridToolbar,
											LoadingOverlay: LinearProgress,
										}}
										selectionModel={selectionModel}
										onSelectionModelChange={(newSelection) => {
											setSelectionModel(newSelection)
										}}
										localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
										componentsProps={{
											toolbar: {
												csvOptions: { disableToolbarButton: true },
												excelOptions: { disableToolbarButton: true },
												printOptions: { disableToolbarButton: true },
												showQuickFilter: false,
												quickFilterProps: { debounceMs: 250 },
											},
										}}
										density={(env.desnse as GridDensity) || 'compact'}
										initialState={{
											columns: {
												columnVisibilityModel: {
													ReceptionID: false,
													id: false,
												},
											},
										}}
										experimentalFeatures={{ columnGrouping: true }}
										sx={{
											'& [class*="MuiDataGrid-columnHeaders"]': {
												// borderTop: '1px solid #95a5a6',
												// borderBottom: '1px solid #95a5a6',
											},
											'& .group-biotic-border-first, & .dynamic-header-first': {
												borderLeft: '1px solid #95a5a6',
											},
											'& .group-biotic-border-last, & .dynamic-header-last': {
												borderRight: '1px solid #95a5a6',
											},
											'& .basic-header, & .additional-info-header, & .biotic-header': {
												backgroundColor: '#bdc3c7',
											},
											'& .add-column, & .basic-info-header, & .dynamic-header': {
												backgroundColor:
													theme.palette.mode === 'dark'
														? 'rgba(81, 81, 81, 1)'
														: 'rgba(224, 224, 224, 1)',
												borderRight: '1px solid #95a5a6',
											},
											'& .basic-info-header.last-basic-header': {
												borderRight: '0 !important',
											},
											'& .MuiDataGrid-columnSeparator': {
												opacity: '0 !important',
												color: 'transparent !important',
											},
											'& .MuiDataGrid-columnHeaderTitleContainer': {
												borderBottom: '0 !important',
												fontSize: '13px',
											},
											'& .MuiDataGrid-cell': {
												fontSize: '13px !important',
												borderRight:
													theme.palette.mode === 'dark'
														? '1px solid rgba(81, 81, 81, 1)'
														: '1px solid rgba(224, 224, 224, 1)',
											},
										}}
									/>
								</Box>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}
export default ByPatient
